import { CALL_API } from '../../../../../../../middlewares/api';
import { url } from '../../../../../../../configs/';
const {
  NEWTUBE_API_SERVER,
} = url;
const FETCH_INTERNAL_LINKS_REQUEST = 'tube/internalLinks/FETCH_INTERNAL_LINKS_REQUEST';
const FETCH_INTERNAL_LINKS_SUCCESS = 'tube/internalLinks/FETCH_INTERNAL_LINKS_SUCCESS';
const FETCH_INTERNAL_LINKS_FAIL = 'tube/internalLinks/FETCH_INTERNAL_LINKS_FAIL';

export default function reducer(state = {
  isLoading: false,
  links: [],
}, action) {
  switch (action.type) {
    case FETCH_INTERNAL_LINKS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_INTERNAL_LINKS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        links: action.response.data,
      });
    default:
      return state;
  }
}

export function fetchInternalLinks() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Internallinks`,
      headers: {
        FunctionCode: 'InternalSystemLink',
        ActionCode: 'Default',
      },
      method: 'GET',
      types: [
        FETCH_INTERNAL_LINKS_REQUEST,
        FETCH_INTERNAL_LINKS_SUCCESS,
        FETCH_INTERNAL_LINKS_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/InternalLinks/reducers/index.js
 **/